import React from 'react';

export const EditIcon = ({ handleModalEdit }) => {

    return (
        <button type="button" className="close" onClick={handleModalEdit} style={{ opacity: 1 }}>
            <svg
                width="32"
                height="32"
                viewBox="0 0 72 72"
                xmlns="http://www.w3.org/2000/svg"
            >
                <g>
                <path 
                    id="Vector"
			        d="M38.406 22.234l11.36 11.36L28.784 54.576l-12.876 4.307c-1.725.577-3.367-1.065-2.791-2.79l4.307-12.876L38.406 22.234zM41.234 19.406l5.234-5.234c1.562-1.562 4.095-1.562 5.657 0l5.703 5.703c1.562 1.562 1.562 4.095 0 5.657l-5.234 5.234L41.234 19.406z"
                    fill="#33B8FF"
                    stroke="#33B8FF" 
                    strokeWidth="2"
                />
                </g>
            </svg>
        </button>
    );
};

export const SaveIcon = ({ handleModalSave }) => {

    return (
        <button type="button" className="close"  onClick={handleModalSave} style={{ opacity: 1 }}>
            <svg
                width="32"
                height="32"
                viewBox="-5.0 -10.0 110.0 135.0"
                xmlns="http://www.w3.org/2000/svg"
            >
                <g>
                    <path 
                        d="m95.125 21.703-16.828-16.828c-0.39062-0.39062-0.89062-0.57812-1.3906-0.57812h-68c-2.5312 0-4.6094 2.0781-4.6094 4.6094v82.188c0 2.5312 2.0781 4.6094 4.6094 4.6094h82.188c2.5312 0 4.6094-2.0781 4.6094-4.6094v-68c0-0.51562-0.20312-1.0156-0.57812-1.3906zm-74.422 60.203v-29.953h58.594v29.953zm0-73.703h45.219v29.953h-45.219z"
                        fill="#33B8FF"
                    />
                    <path 
                        d="m50 12.375h8.9219c1.0781 0 1.9531 1.0781 1.9531 1.9531v17.703c0 1.0781-0.875 1.9531-1.9531 1.9531h-8.9219c-1.0781 0-1.9531-1.0781-1.9531-1.9531v-17.703c0-1.0781 0.875-1.9531 1.9531-1.9531z"
                        fill="#33B8FF"
                    />
                </g>
            </svg>
        </button>
    );
};